import { render } from "./MainApp.vue?vue&type=template&id=29bed86a&scoped=true"
import script from "./MainApp.vue?vue&type=script&lang=js"
export * from "./MainApp.vue?vue&type=script&lang=js"

import "./MainApp.vue?vue&type=style&index=0&id=29bed86a&scoped=true&lang=css"

import exportComponent from "/Users/muoitrinh/Documents/Projects/BetmintonApp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29bed86a"]])

export default __exports__